export default __webpack_public_path__ + "static/media/folder.39ef9ca3.svg";